/**
 * Returns a deep-copy of an object
 * @param {Object (| Array)} obj : Object to deep-copy
 */
function createDeepCopy(obj) {
	return JSON.parse(JSON.stringify(obj));
}

export { createDeepCopy };
